module.exports = __webpack_public_path__ + "static/media/panitas.e4bba5e3.jpeg";